<template>
  <v-dialog v-model="dialog.isOpened" max-width="850" persistent scrollable>
    <v-card flat class="bonus-dialog">
      <div class="dialog-header">
        <div class="header-main">
          <div class="dialog-icon">
            <v-icon size="20">{{ prependIcon }}</v-icon>
          </div>
          <div class="header-title">
            <div class="dialog-title">{{ dialog?.title }}</div>
            <div v-if="dialog?.subtitle" class="dialog-subtitle">
              {{ dialog.subtitle }}
            </div>
          </div>
        </div>
        <div class="header-meta">
          <div v-if="dialog?.value?.status" class="status-container">
            <span
              class="status-value"
              :class="dialog?.value?.status ? 'active' : 'inactive'"
            >
              <span class="status-dot"></span>
              {{ dialog?.value?.status ? "Active" : "Inactive" }}
            </span>
          </div>
          <v-btn icon variant="text" size="38" class="close-btn" @click="close">
            <v-icon size="19">mdi-close</v-icon>
            <v-tooltip activator="parent" location="top">Close</v-tooltip>
          </v-btn>
        </div>
      </div>
      <v-card-text class="dialog-body">
        <slot></slot>
        <!-- ACTIVITY INFORMATION -->
        <div
          v-if="dialog?.value?.updatedBy || dialog?.value?.createdBy"
          class="section-title activity-title"
        >
          <v-icon size="19">mdi-history</v-icon>
          <span>Activity Information</span>
        </div>

        <v-row class="activity-row">
          <!-- CREATED BY -->
          <v-col v-if="dialog?.value?.createdBy" cols="12" md="6">
            <div class="activity-card">
              <div class="activity-icon created">
                <v-icon size="20"> mdi-account-plus-outline </v-icon>
              </div>

              <div class="activity-content">
                <div class="info-label">CREATED BY</div>

                <div class="activity-value">
                  {{ dialog?.value?.createdBy || "-" }}
                </div>

                <div class="activity-date">
                  <v-icon size="15"> mdi-calendar-outline </v-icon>
                  <span>{{ dialog?.value?.createdAt || "-" }}</span>
                </div>
              </div>
            </div>
          </v-col>

          <!-- UPDATED BY -->
          <v-col v-if="dialog?.value?.updatedBy" cols="12" md="6">
            <div class="activity-card">
              <div class="activity-icon updated">
                <v-icon size="20"> mdi-account-edit-outline </v-icon>
              </div>

              <div class="activity-content">
                <div class="info-label">UPDATED BY</div>

                <div class="activity-value">
                  {{ dialog?.value?.updatedBy || "-" }}
                </div>

                <div class="activity-date">
                  <v-icon size="15"> mdi-calendar-outline </v-icon>
                  <span>{{ dialog?.value.updatedAt || "-" }}</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <div v-if="!hideFooter" class="dialog-footer">
        <div class="footer-left">
          <v-icon size="17" class="footer-icon">mdi-information-outline</v-icon>
          <span>Review the information before saving.</span>
        </div>
        <div class="footer-actions">
          <v-btn variant="text" class="cancel-btn" @click="close">Cancel</v-btn>
          <v-btn
            :loading="loading"
            :disabled="saveDisabled"
            class="save-btn"
            @click="save"
            elevation="0"
          >
            <v-icon size="17" class="mr-1">mdi-content-save-outline</v-icon>
            Save
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "pinia";
import { useUiStore } from "@/store";
import { formatDateTime } from "@/shared/utills/date";

export default {
  name: "MidScreenDialog",
  props: {
    prependIcon: {
      type: String,
      default: "mdi-tag-plus",
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    closeOnRouteBack: {
      type: Boolean,
      default: true,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useUiStore, {
      dialog: "getMidDialog",
      loading: "getLoading",
    }),
  },
  methods: {
    formatDateTime,
    close() {
      if (this.closeOnRouteBack) this.$router.back();
      this.$closeDialog();
      this.$emit('close')
    },
    save() {
      this.$emit("save");
    },
  },
};
</script>

<style scoped>
.bonus-dialog {
  border-radius: 18px !important;
  overflow: hidden;
}
.dialog-body {
  background: #f8fafc;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 20px;
  background: #fff;
  border-top: 1px solid #eef0f3;
}
.footer-left {
  display: flex;
  align-items: center;
  color: #8a94a6;
  font-size: 10.5px;
}
.footer-icon {
  color: #9aa3b2;
  margin-right: 6px;
}
.footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cancel-btn {
  min-width: 78px !important;
  height: 38px !important;
  color: #64748b !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-radius: 9px !important;
}
.cancel-btn:hover {
  background: #f8fafc !important;
}
.save-btn {
  min-width: 90px !important;
  height: 38px !important;
  color: #fff !important;
  background: #f59e0b !important;
  border-radius: 9px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}
.save-btn:hover {
  background: #d97706 !important;
}
.dialog-header {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 18px;
  background: #fff;
  border-bottom: 1px solid #e9edf2;
  box-sizing: border-box;
}
.header-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
}
.dialog-icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d97706;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 11px;
}
.header-title {
  min-width: 0;
  margin-left: 12px;
}
.dialog-title {
  color: #172033;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dialog-subtitle {
  margin-top: 4px;
  color: #94a3b8;
  font-size: 10.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-meta {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-left: auto;
}
.meta-label {
  margin-bottom: 6px;
  color: #94a3b8;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.status-value {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  font-size: 10.5px;
  font-weight: 700;
}
.status-dot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
}
.status-value.active {
  color: #15803d;
}
.status-value.active .status-dot {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.12);
}
.status-value.inactive {
  color: #b91c1c;
}
.status-value.inactive .status-dot {
  background: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
}
.close-btn {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  flex: 0 0 40px !important;
  margin-left: 2px;
  color: #dc2626 !important;
  background: #fef2f2 !important;
  border: 1px solid #fecaca;
  border-radius: 9px !important;
}
.activity-title {
  margin-top: 22px;
  margin-bottom: 12px;
}
.activity-row {
  margin: 0 -6px;
}
.activity-row > .v-col {
  padding-top: 6px;
  padding-bottom: 6px;
}
.activity-card {
  min-height: 96px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border: 1px solid #dfe5ec;
  border-radius: 12px;
  background: #ffffff;
}
.activity-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
}
.activity-icon.created {
  background: #f1f5f9;
  color: #607d9c;
}
.activity-icon.updated {
  background: #f1e8ff;
  color: #8b3ffc;
}
.activity-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.activity-content .info-label {
  margin-bottom: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #8494aa;
  letter-spacing: 0.8px;
}
.activity-value {
  min-height: 18px;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #536b86;
}
.activity-date {
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 17px;
  color: #91a0b5;
  font-size: 11px;
  line-height: 16px;
}
.activity-date .v-icon {
  color: #91a0b5;
  flex-shrink: 0;
}
.status-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
.meta-label {
  font-size: 11px;
  font-weight: 600;
  color: #8494aa;
}
.status-value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
}

.status-value.active {
  color: #16a34a;
}

.status-value.inactive {
  color: #ef4444;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}
</style>
